import firebase from 'firebase/compat/app'

import { F } from '../context'
import { GetVariableValue } from '../hooks'
import { assetsId, companiesId, profilesId } from '../services/cms'
import {
  CURRENT_USER,
  CURRENT_USER_COMPANIES,
  CURRENT_USER_COMPANY_ID,
  Collection,
  TableQueryFilterOperator,
  VariableSourceType,
  convertRecord,
  getCollectionProperties,
  operators,
  showError,
} from './index'

export const postCompaniesForParentWindow = async (
  f: F,
  collections: Collection[],
  getVariableValue: GetVariableValue
) => {
  const { firestorePrefix, firestore } = f
  const profilesProperties = getCollectionProperties(collections, profilesId)
  const companiesProperties = getCollectionProperties(collections, companiesId)
  const assetsProperties = getCollectionProperties(collections, assetsId)
  try {
    const currentUserId = await getVariableValue({
      source: { type: VariableSourceType.globalVariable, variableName: 'currentUserId' },
    })
    firestore
      .collection(firestorePrefix + profilesId)
      .doc(currentUserId)
      .onSnapshot({
        next: res => {
          const currentUser = convertRecord(res, profilesProperties, assetsProperties)
          window.parent.postMessage(`${CURRENT_USER} ${JSON.stringify({ currentUser })}`, '*')
        },
        error: err => showError(err),
      })
    firestore
      .collection(firestorePrefix + companiesId)
      .where('memberIds', operators[TableQueryFilterOperator.contains], currentUserId)
      .onSnapshot(
        { includeMetadataChanges: true },
        {
          next: res => {
            if (!res.metadata.fromCache && !res.metadata.hasPendingWrites) {
              const companies = res.docs.map(el => convertRecord(el, companiesProperties, assetsProperties))
              window.parent.postMessage(`${CURRENT_USER_COMPANIES} ${JSON.stringify({ companies })}`, '*')
            }
          },
          error: err => showError(err),
        }
      )
    window.addEventListener('message', async e => {
      if (typeof e.data === 'string') {
        if (e.data.startsWith(CURRENT_USER_COMPANY_ID)) {
          const data = JSON.parse(e.data.replace(CURRENT_USER_COMPANY_ID, ''))
          const companyId = data.companyId
          try {
            await firestore
              .collection(firestorePrefix + profilesId)
              .doc(currentUserId)
              .update({
                companyId,
                updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
              })
          } catch (err: any) {
            showError(err)
          }
        }
      }
    })
  } catch (err: any) {
    showError(err)
  }
}
